export default __webpack_public_path__ + "static/media/rzd.fe71cc23.jpg";